import Vue from "vue";
import { store } from "../store";
// import { DateTime } from "luxon";
Vue.filter("time", (value: number) => {
    // replace Luxon with vanilla date formatting to reduce bundle size
    return new Date(value).toLocaleTimeString(store.getters.app.selectedLanguage.code, { hour: "2-digit", minute: "2-digit" });
    // return DateTime.fromMillis(value).toLocaleString(DateTime.TIME_24_SIMPLE);
});
